import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    margin: theme.spacing(2),
    alignItems: "center",
  },
  icon: {
    marginRight: theme.spacing(1),
  },
}));
